<template>
  <div v-if="initialised">
    <activity :current-user="crud.data" :readonly="true" />
  </div>
</template>

<script type="text/babel">
import Activity from "./partials/Activity.vue";
import format from "../../mixins/format";

export default {
  components: {
    Activity,
  },
  mixins: [format],

  data() {
    return {
      crud: null,
      form: new window.AppForm({
        status: "Active",
        core_compliance: 0,
        profile_photo: "",
        profile_photo_time: "",
        van_photo: "",
        van_photo_time: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        mobile: "",
        company_name: "",
        abn: "",
        password: "",
        comments: "",
        role: "technician",
        brands: [],
        service_types: [],
        type: null,
        contractor_job_commission: 0,
        contractor_booking_commission: 0,
        franchisee_job_commission: 0,
        franchisee_booking_commission: 0,
        admin_fee: 0,
        marketing_fee: 0,
        supervisees: [],
        addresses: [
          {
            id: null,
            street: null,
            city: null,
            state: null,
            postcode: null,
          },
        ],
      }),

      initialised: false,
    };
  },

  computed: {
    id() {
      if (this.$route.params.id) {
        return Number(this.$route.params.id);
      }

      return false;
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.crud = new window.AppCrud("user", false, "edit");
      this.crud.initFormData(this.form).then(() => {
        this.initialised = true;
      });
    },
  },
};
</script>
